/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';
function UndoIcon(props, svgRef) {
    return (React.createElement("svg", Object.assign({ "data-sanity-icon": "undo", width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: svgRef }, props),
        React.createElement("path", { d: "M5.88468 17C7.32466 19.1128 9.75033 20.5 12.5 20.5C16.9183 20.5 20.5 16.9183 20.5 12.5C20.5 8.08172 16.9183 4.5 12.5 4.5C8.08172 4.5 4.5 8.08172 4.5 12.5V13", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M7.5 11L4.56189 13.5L2 10.5", stroke: "currentColor", strokeWidth: 1.2 })));
}
const ForwardRef = React.forwardRef(UndoIcon);
export default ForwardRef;
//# sourceMappingURL=undoIcon.js.map